export default __webpack_public_path__ + "static/media/kp11.aec534ef.jpg";